module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.ad19729.woff2";